import React from 'react';
import { TruckIcon } from '@heroicons/react/24/outline';
import VehicleManager from '@/components/VehicleManager';

const VehiclesPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 py-8 px-4">
      <div className="max-w-4xl mx-auto">
        {/* Header */}
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-blue-600 rounded-full mb-4">
            <TruckIcon className="w-8 h-8 text-white" />
          </div>
          <h1 className="text-3xl font-bold text-gray-900 mb-2">
            Mis Vehículos
          </h1>
          <p className="text-gray-600">
            Gestiona tus vehículos y establece cuál usar por defecto
          </p>
        </div>

        {/* Vehicle Manager */}
        <div className="bg-white rounded-2xl shadow-xl p-8">
          <VehicleManager />
        </div>

        {/* Información adicional */}
        <div className="mt-6 text-center">
          <p className="text-sm text-gray-500">
            Puedes agregar múltiples vehículos y establecer uno como predeterminado para tus citas.
          </p>
        </div>
      </div>
    </div>
  );
};

export default VehiclesPage;
